import { getUnixTime as unixTime } from 'date-fns';

const getUnixTime = date => unixTime(date || new Date());

export default getUnixTime;
